import { useCallback } from "react";
import { useTranslation } from "react-i18next";
import { Tooltip } from "components/common/Tooltip";
import { BLOCKED_LABEL_KEYS } from "./constants";
import { RevertButton } from "./RevertButton";
import type { ActionControlProps } from "./types";

export const ActionControl = ({
  entryId,
  planCount,
  action,
  direction,
  blockedReason,
  isReverting,
  onRevert,
}: ActionControlProps) => {
  const { t } = useTranslation();

  const handleClick = useCallback(() => {
    onRevert({ entryId, direction, planCount });
  }, [onRevert, entryId, direction, planCount]);

  if (action === null) return null;

  if (blockedReason === null) {
    return (
      <RevertButton
        direction={direction}
        isBlocked={false}
        isReverting={isReverting}
        onClick={handleClick}
      />
    );
  }

  return (
    <Tooltip
      label={t(BLOCKED_LABEL_KEYS[direction], {
        reason: t(
          `smartSurveyor.history.blocked.${blockedReason.key}`,
          blockedReason.params,
        ),
      })}
    >
      <RevertButton
        direction={direction}
        isBlocked
        isReverting={isReverting}
        onClick={handleClick}
      />
    </Tooltip>
  );
};
